import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';
import { pricingBannersDesktopBreakpoint } from 'organisms/pricing/PricingPlanBanners.styles';

export const PricingBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${palette.fog};
  background-color: ${palette.white};
  width: 310px;
  min-height: 475px;
  margin: 0 auto;
  padding: 24px 24px;
  box-sizing: border-box;

  @media all and (min-width: ${layout.md}) {
    width: 33%;
    padding-bottom: 0;
    min-height: 500px;
  }
`;

export const SubtitleWrapper = styled.div`
  margin-top: 16px;
`;

export const DescriptionParagraph = styled.p`
  margin-bottom: 8px;
  line-height: 1.2;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
`;

export const CTAContainer = styled.div`
  margin: 32px 0;
  line-height: 1.2;
  text-align: center;

  a {
    min-width: 256px;
  }
`;

export const FeaturesList = styled.ul`
  list-style-type: none;
  width: 256px;
  line-height: 1.6;
  padding: 0;

  li {
    display: flex;

    &:before {
      // this is intended to produce the expected layout
      // replacing the pseudo elements for the bullet point from marker to before
      content: "\\2022";
    }

    & > span {
      font-size: 14px;
      font-weight: 300;
      padding-left: 10px;
    }
  }
`;

export const PriceSubtitle = styled.span`
  font-weight: 300;
  line-height: 1.1;
  font-size: 12px;
  margin-top: 8px;
`;

export const BottomTextWrapper = styled.div`
  display: none;
  margin: 24px 0;

  @media all and (min-width: ${pricingBannersDesktopBreakpoint}) {
    display: block;
  }
`;
